import {
    FETCHED_BLOCK,
    FETCHED_BLOCKS,
    FETCHING_BLOCKS,
    UPDATED_BLOCK,
    DELETED_BLOCK,
    FETCHED_BLOCK_TYPES,
    FETCHED_BLOCK_REVISIONS,
    FETCHED_BLOCK_TRANSLATIONS,
    UPDATED_BLOCK_TRANSLATION,
    FETCHED_BLOCK_SITE_TRANSLATION,
    DISABLED_BLOCK,
    ENABLED_BLOCK,
    DISABLED_TRANSLATION,
    ENABLED_TRANSLATION,
    DELETED_BLOCK_TRANSLATION,
    DELETED_BLOCK_REVISION,
    FETCHED_TRANSLATION_REVISIONS,
    ACTIVATED_BLOCK_REVISION,
    ACTIVATED_TRANSLATION_REVISION,
    FETCHED_BLOCKS_BY_TERMS,
    ADD_IMAGES_IN_BLOCK_EDIT,
    ADD_BLOCK_IMAGE_SETTING,
    ADD_BLOCK_VIDEO_SETTING,
    REMOVE_BLOCK_IMAGE,
    UPDATE_BLOCK_CROPPED_IMAGE,
    UPDATE_BLOCK_IMAGE_META,
    UPDATE_BLOCK_THUMB_CROPPED_IMAGE,
    UPDATE_BLOCK_IMAGES_SORT_ORDER,
    SELECT_BLOCK_TYPE,
    SELECT_BLOCK_NAME,
    SELECT_BLOCK_DESTINATION,
    SELECT_BLOCK_TRIP_FORMAT,
    SELECT_BLOCK_TYPE_OF_WORK,
    SELECT_BLOCK_TITLE,
    SELECT_BLOCK_BODY,
    SELECT_BLOCK_BUTTON_TEXT,
    UPDATE_VIDEO_URL_FIELD,
    TOGGLE_PAGE_PICKER_POPUP,
    PICK_BLOCK_PAGE,
} from './types';

export function fetchedBlocks(data, totalPages) {
    return {
        type: FETCHED_BLOCKS,
        payload: {
            data: data,
            totalPages: totalPages,
        },
    };
}

export function fetchingBlocks() {
    return {
        type: FETCHING_BLOCKS,
        payload: true,
    };
}

export function fetchedBlock(block) {
    return {
        type: FETCHED_BLOCK,
        block,
    };
}

export function updatedBlock(block) {
    return {
        type: UPDATED_BLOCK,
        block,
    };
}

export function deletedBlock(block) {
    return {
        type: DELETED_BLOCK,
        block,
    };
}

export function changeBlockType(blockTypeId) {
    return {
        type: SELECT_BLOCK_TYPE,
        blockTypeId,
        touched: true,
    };
}

export function changeBlockDestination(blockDestinationId) {
    return {
        type: SELECT_BLOCK_DESTINATION,
        blockDestinationId,
        touched: true,
    };
}

export function changeBlockTripFormat(blockTripFormatId) {
    return {
        type: SELECT_BLOCK_TRIP_FORMAT,
        blockTripFormatId,
        touched: true,
    };
}

export function changeBlockTypeOfWork(blockTypeOfWorkId) {
    return {
        type: SELECT_BLOCK_TYPE_OF_WORK,
        blockTypeOfWorkId,
        touched: true,
    };
}

export function changeBlockName(name) {
    return {
        type: SELECT_BLOCK_NAME,
        name,
        touched: true,
    };
}

export function changeBlockTitle(title) {
    return {
        type: SELECT_BLOCK_TITLE,
        title,
        touched: true,
    };
}

export function changeBlockBody(body) {
    return {
        type: SELECT_BLOCK_BODY,
        body,
        touched: true,
    };
}

export function changeBlockButtonText(button_text) {
    return {
        type: SELECT_BLOCK_BUTTON_TEXT,
        button_text,
        touched: true,
    };
}

export function updateVideoUrlField(id, url) {
    return {
        type: UPDATE_VIDEO_URL_FIELD,
        id,
        url,
        touched: true,
    };
}

export function fetchedBlockTypes(blockTypes) {
    return {
        type: FETCHED_BLOCK_TYPES,
        blockTypes,
    };
}

export function fetchedBlockTranslations(blockTranslations) {
    return {
        type: FETCHED_BLOCK_TRANSLATIONS,
        blockTranslations,
    };
}

export function fetchedBlockSiteTranslation(blockTranslation) {
    return {
        type: FETCHED_BLOCK_SITE_TRANSLATION,
        blockTranslation,
    };
}

export function updatedBlockTranslation(blockTranslation) {
    return {
        type: UPDATED_BLOCK_TRANSLATION,
        blockTranslation,
        touched: false,
    };
}

export function deletedBlockTranslation(translation) {
    return {
        type: DELETED_BLOCK_TRANSLATION,
        translation,
    };
}

export function disabledBlock(block) {
    return {
        type: DISABLED_BLOCK,
        block,
    };
}

export function enabledBlock(block) {
    return {
        type: ENABLED_BLOCK,
        block,
    };
}

export function disabledTranslation(translationId) {
    return {
        type: DISABLED_TRANSLATION,
        payload: translationId,
    };
}

export function enabledTranslation(translationId) {
    return {
        type: ENABLED_TRANSLATION,
        payload: translationId,
    };
}

export function fetchedBlockRevisions(blockRevisions) {
    return {
        type: FETCHED_BLOCK_REVISIONS,
        blockRevisions,
    };
}

export function deletedBlockRevision(revision) {
    return {
        type: DELETED_BLOCK_REVISION,
        revision,
    };
}

export function activatedBlockRevision(revisionId) {
    return {
        type: ACTIVATED_BLOCK_REVISION,
        revisionId,
    };
}

export function fetchedTranslationRevisions(translationRevisions) {
    return {
        type: FETCHED_TRANSLATION_REVISIONS,
        translationRevisions,
    };
}

export function activatedTranslationRevision(revisionId) {
    return {
        type: ACTIVATED_TRANSLATION_REVISION,
        revisionId,
    };
}

export function gotBlocksByTerms(blocks, pageId) {
    return {
        type: FETCHED_BLOCKS_BY_TERMS,
        payload: {
            blocks,
            pageId,
        },
    };
}

export function updateImagesInTheBlockEdit(images) {
    return {
        type: ADD_IMAGES_IN_BLOCK_EDIT,
        payload: {
            images,
            touched: true,
        },
    };
}

export function selectImageSettingInTheBlockEdit(selectedOptions, forSetting) {
    selectedOptions =
        selectedOptions !== undefined && selectedOptions instanceof Array
            ? selectedOptions
            : [selectedOptions];

    return {
        type: ADD_BLOCK_IMAGE_SETTING,
        payload: {
            selectedOptions,
            forSetting,
            touched: true,
        },
    };
}

export function selectVideoSettingInTheBlockEdit(selectedOptions, forSetting) {
    selectedOptions =
        selectedOptions !== undefined && selectedOptions instanceof Array
            ? selectedOptions
            : [selectedOptions];

    return {
        type: ADD_BLOCK_VIDEO_SETTING,
        payload: {
            selectedOptions,
            forSetting,
            touched: true,
        },
    };
}

export function deleteImageInTheBlockEdit(image, index) {
    return {
        type: REMOVE_BLOCK_IMAGE,
        payload: {
            image,
            index,
            touched: true,
        },
    };
}

export function updateCroppedImageInTheBlockEdit(
    index,
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_BLOCK_CROPPED_IMAGE,
        payload: {
            index,
            image,
            imageUrlBlob,
            imageBlobObject,
            touched: true,
        },
    };
}

export function updateImageMetaInTheBlockEdit(index, imageMeta) {
    const {title, alt, link, name, filename, description} = imageMeta;
    let imageMetaUpdated = {
        title,
        alt,
        link,
        name:
            name !== undefined ? name : filename !== undefined ? filename : '',
        description,
    };

    return {
        type: UPDATE_BLOCK_IMAGE_META,
        payload: {
            index,
            imageMeta: imageMetaUpdated,
            touched: true,
        },
    };
}

export function updateThumbCroppedImageInTheBlockEdit(
    image,
    imageUrlBlob,
    imageBlobObject
) {
    return {
        type: UPDATE_BLOCK_THUMB_CROPPED_IMAGE,
        payload: {
            image: image,
            imageUrlBlob: imageUrlBlob,
            imageBlobObject: imageBlobObject,
            touched: true,
        },
    };
}

export function updateBlockImagesSortOrder(images) {
    return {
        type: UPDATE_BLOCK_IMAGES_SORT_ORDER,
        payload: {
            images,
            touched: true,
        },
    };
}

export function togglePagePickerPopup() {
    return {
        type: TOGGLE_PAGE_PICKER_POPUP,
    };
}

export function onPickBlockPage(pageId, pageTitle) {
    return {
        type: PICK_BLOCK_PAGE,
        payload: {
            pageId,
            pageTitle,
            touched: true,
        },
    };
}



// WEBPACK FOOTER //
// ./src/containers/blocks/actions.js